// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.methanol_detector_hold_enum */
var MethanolDetectorHoldEnum;
(function (MethanolDetectorHoldEnum) {
    MethanolDetectorHoldEnum["SNOOZE"] = "SNOOZE";
    MethanolDetectorHoldEnum["OFF"] = "OFF";
})(MethanolDetectorHoldEnum || (MethanolDetectorHoldEnum = {}));
;
export default MethanolDetectorHoldEnum;
/** Zod schema for methanol_detector_hold_enum */
export const methanolDetectorHoldEnum = z.nativeEnum(MethanolDetectorHoldEnum);
//# sourceMappingURL=MethanolDetectorHoldEnum.js.map